import { Builder } from "@builder.io/react";
import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import ConvertUSD from "../../../../../utils/convertUSD";

const ProgressBar = ({ goal, raised, loader, currentCurrency, isSquared, showProgressBar = true }) => {
  const [percentage, setPercentage] = useState(0);

  const handlePercentage = (raised, goal) => {
    return `${((Number(raised) / Number(goal)) * 100).toFixed(2)}`;
  };

  useEffect(() => {
    if (goal && raised) {
      const percentageCalc = handlePercentage(
        raised,
        ConvertUSD(currentCurrency, goal, false),
      );
      setPercentage(percentageCalc);
    }
  }, [goal, raised]);

  if(!showProgressBar) { 
    return null;
  }

  return loader ? (
    <div className={`h-[20px] md:h-6 w-full bg-[#A2DDFF] ${isSquared ? 'rounded-none' : 'rounded-md'} relative overflow-visible`}>
      {/* Filled bar */}
      <div
        className={`absolute h-full bg-[#00A3DA] left-0 top-0 ${isSquared ? 'rounded-none' : 'rounded-md'}`}
        style={{ width: `${percentage}%` }}
      ></div>

      <div
        className="absolute w-[100px] flex flex-col items-center justify-center gap-2"
        style={{
          top: "-8px",
          left: `calc(${percentage}% - 50px)`,
        }}
      >
        <div className={`w-[38px] h-[38px] bg-[#F60462] ${isSquared ? 'rounded-none' : 'rounded-full'} flex items-center justify-center`}>
          <div className="w-[20px] h-[20px] bg-white rounded-full"></div>
        </div>

        {/* Label under progress */}
        <div className="font-bold font-inter text-[#00A3DA] text-center">
          We are here
        </div>
      </div>
      {percentage <= 93 && (
        <div
          className="absolute w-[100px] flex flex-col items-end justify-center gap-2"
          style={{
            top: "-8px",
            left: `calc(100% - 90px)`,
          }}
        >
          <div className={`w-[38px] h-[38px] bg-[#00A3DA] ${isSquared ? 'rounded-none' : 'rounded-full'} flex items-center justify-center`}>
            <div className={`w-[20px] h-[20px] bg-white ${isSquared ? 'rounded-none' : 'rounded-full'}`}></div>
          </div>

          {/* Label under progress */}
          <div className="font-bold font-inter text-[#00A3DA] text-center">
            The goal
          </div>
        </div>
      )}
    </div>
  ) : (
    <Skeleton
      height={52}
      containerClassName={`${isSquared ? 'rounded-none' : 'rounded-md'}`}
      baseColor="bg-[#A2DDFF] "
    />
  );
};

export default ProgressBar;

Builder.registerComponent(ProgressBar, {
  name: "ProgressBar",
  inputs: [
    {
      name: "goal",
      type: "number",
      defaultValue: 1000000,
    },
    {
      name: "raised",
      type: "number",
      defaultValue: 900000,
    },
  ],
});
